var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 17H5.33333C4.59695 17 4 16.3732 4 15.6V5.8C4 5.0268 4.59695 4.4 5.33333 4.4H6.66667V3H8V4.4H12V3H13.3333V4.4H14.6667C15.403 4.4 16 5.0268 16 5.8V15.6C16 16.3732 15.403 17 14.6667 17ZM5.33333 8.6V15.6H14.6667V8.6H5.33333ZM5.33333 5.8V7.2H14.6667V5.8H5.33333ZM13.3333 14.2H12V12.8H13.3333V14.2ZM10.6667 14.2H9.33333V12.8H10.6667V14.2ZM8 14.2H6.66667V12.8H8V14.2ZM13.3333 11.4H12C12 11.4 11.6041 10.3771 12 10H13.3333V11.4ZM10.6667 11.4H9.33333V10H10.6667V11.4ZM8 11.4H6.66667V10H8V11.4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-icon.922176e51550f43e3b06d86962d26704.svg";